import HTTPService from './HTTPService';

export function PlanListService() {
  return HTTPService.get('internal/api/master-data/plans');
}

export function PlanCreateService({ name, price }) {
  return HTTPService.post('internal/api/master-data/plans', { name, price });
}
